<template>
    <div class="picker-container">
        <div class="picker-mask"></div>
        <div class="picker-warpper" :class="pickerFlag ? 'action_translate_show' : 'action_translate_hide'">
            <div class="picker-header">
                <h2>预约视话咨询开始时间</h2>
                <i @click="closePicker"></i>
            </div>
            <div class="picker-content">
                <ul>
                    <li v-for="(item, index) in dataList" :key="index" :class="index == selectedIndex ? 'picker-item-active' : ''" @click="selectedDate(item, index)">
                        <div class="picker-item-date">
                            <span>{{ formatDate(item.resDate) }}</span>
                            <span>{{ getWeek(item.resDate) }}</span>
                            <span>{{ formatTime(item.resTimeIntervalStart) + '-' + formatTime(item.resTimeIntervalEnd) }}</span>
                            <span>剩{{ item.numberCount }}</span>
                        </div>
                        <div class="picker-item-checkbox">
                            <div v-if="item.status == 2">满号</div>
                            <div v-else-if="item.status == 0">停诊</div>
                            <i v-else></i>
                        </div>
                    </li>
                    <!-- <li class="picker-item-active">
                        <div class="picker-item-date">
                            <span>05/26</span>
                            <span>周日</span>
                            <span>19:00-21:00</span>
                            <span>剩3</span>
                        </div>
                        <div class="picker-item-checkbox">
                            <i></i>
                        </div>
                    </li>
                    <li>
                        <div class="picker-item-date">
                            <span>05/26</span>
                            <span>周日</span>
                            <span>19:00-21:00</span>
                            <span>剩3</span>
                        </div>
                        <div class="picker-item-checkbox">
                            <i></i>
                        </div>
                    </li> -->
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        doctorInfo: {
            type: Object,
            default () {
                return {}
            }
        },
        dataList: {
            type: Array,
            default () {
                return {}
            }
        }
    },
    data() {
        return {
            selectedIndex: -1,
            pickerFlag: false
        }
    },
    created() {
        this.pickerFlag = true;
    },
    methods: {
        /**
         * 转换MM/DD的日期格式
         * @param {date} date 日期(YYYY-MM-DD)
         * @return {String} MM/DD
         */
        formatDate(date) {
            let dateArr = date.split('-');
            return dateArr[1] + '/' + dateArr[2];
        },
        /**
         * 转换HHmmss的日期格式
         * @param {String} date 日期(HHmmss)
         * @return {String} HH:mm
         */
        formatTime(date, type) {
            if(type === 2) {
                return date.substring(0, 2) + ':' + date.substring(2, 4) + ':' + date.substring(4, 6);
            }
            return date.substring(0, 2) + ':' + date.substring(2, 4);
        },
        /**
         * 根据日期获取当前星期
         * @param {date} date 日期
         * @return {String} week
         */
        getWeek(date) {
            const weekDay = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
            let myDate = new Date(date);
            return weekDay[myDate.getDay()];
        },
        /**
         * 选中行
         */
        selectedDate(item, index) {
          if(item.status == 1 && item.numberCount > 0) {
            this.pickerFlag = false;
            this.$set(this.doctorInfo, 'resTime', item.resDate + ' ' + this.formatTime(item.resTimeIntervalStart, 2));
            this.$set(this.doctorInfo, 'numberId', item.id);
            this.$emit('createForm', this.doctorInfo);
            }
        },
        getNumberList(schedulId, dataInfo) {
          //作废
            this.$http.getNumberList({
                schedulId: schedulId
            }).then(res => {
                let numberId = '';
                
                let startTime = dataInfo.resDate + ' ' + this.formatTime(dataInfo.resTimeIntervalStart, 2);
                let endTime = dataInfo.resDate + ' ' + this.formatTime(dataInfo.resTimeIntervalEnd, 2);
                console.log(startTime);
                console.log(dataInfo.resTimeIntervalStart);
                for(let item of res.values()) {
                    if(startTime == item.startTime && endTime == item.endTime) {
                        numberId = item.id;
                    }
                }
                if(numberId !== '') {
                    this.pickerFlag = false;
                    this.$set(this.doctorInfo, 'resTime', startTime);
                    this.$set(this.doctorInfo, 'numberId', numberId);
                    this.$emit('createForm', this.doctorInfo);
                } else {
                    this.$toast("未获取到预约号源ID");
                }
            })
        },
        /**
         * 关闭Picker
         */
        closePicker() {
            let that = this;
            that.pickerFlag = false;
            let pickerTime = setTimeout(function(){
                that.$emit('closePicker');
                clearTimeout(pickerTime);
            }, 400)
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/common/schedulPicker.vue